(() => {
  'use strict';

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function waitForCore() {
    for (let attempt = 0; attempt < 80; attempt += 1) {
      if (window.OPSArtworkLibraryCore?.get) return window.OPSArtworkLibraryCore;
      await delay(50);
    }
    return null;
  }

  async function waitForUploadInput() {
    for (let attempt = 0; attempt < 40; attempt += 1) {
      const input = document.querySelector('.custom-upload-block .custom-upload-input');
      if (input) return input;
      await delay(100);
    }
    return null;
  }

  function extensionFor(type) {
    return ({
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'image/webp': 'webp',
      'image/gif': 'gif',
      'image/svg+xml': 'svg',
      'application/pdf': 'pdf'
    })[type] || 'png';
  }

  function freshFile(blob, record) {
    if (blob instanceof File) return blob;
    const base = String(record?.name || 'selected-artwork').trim() || 'selected-artwork';
    const name = /\.[a-z0-9]{2,6}$/i.test(base)
      ? base
      : base + '.' + extensionFor(blob.type || record?.type);
    return new File([blob], name, {
      type: blob.type || record?.type || 'image/png',
      lastModified: Date.now()
    });
  }

  async function importArtwork() {
    const params = new URLSearchParams(window.location.search);
    const artworkId = String(params.get('opsArtwork') || localStorage.getItem('opsPendingArtworkId') || '').trim();
    if (!artworkId) return;

    const [input, core] = await Promise.all([waitForUploadInput(), waitForCore()]);
    if (!input || !core) return;
    const record = await core?.get?.(artworkId);
    const source = record?.originalFile instanceof Blob
      ? record.originalFile
      : record?.file instanceof Blob
        ? record.file
        : null;
    if (!source) return;

    const status = input.closest('.custom-upload-block')?.querySelector('.artwork-upload-status');
    try {
      const transfer = new DataTransfer();
      const file = freshFile(source, record);
      transfer.items.add(file);
      input.files = transfer.files;
      input.dataset.opsArtworkId = artworkId;
      if (status) status.textContent = 'Using ' + (record.name || file.name) + ' from My Artwork…';
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.closest('.custom-upload-block')?.setAttribute('data-ops-artwork-imported', 'true');
      localStorage.removeItem('opsPendingArtworkId');
      await core.recordUsage?.(artworkId, {
        makerId: 'product-upload',
        route: window.location.pathname,
        source: 'print-this-artwork'
      });
    } catch (error) {
      if (status) status.textContent = 'The saved artwork could not be imported automatically. Choose the file manually instead.';
      console.warn('OPS artwork handoff failed.', error);
    }
  }

  const boot = () => importArtwork().catch((error) => console.warn('OPS artwork handoff failed.', error));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
